const LOCATION_CHANGE_EVENT = 'location_change';

export function subscribeToPageChange(track: (url: string) => void) {
  let previousTrackedUrl = '';

  window.addEventListener('popstate', function () {
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
  });

  window.addEventListener('hashchange', function () {
    window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
  });

  const nativePushState = window.history.pushState;
  if (typeof nativePushState === 'function') {
    window.history.pushState = function (state, unused, url) {
      nativePushState.call(window.history, state, unused, url);
      window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
    };
  }

  const nativeReplaceState = window.history.replaceState;
  if (typeof nativeReplaceState === 'function') {
    window.history.replaceState = function (state, unused, url) {
      nativeReplaceState.call(window.history, state, unused, url);
      window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
    };
  }

  window.addEventListener(LOCATION_CHANGE_EVENT, function () {
    const currentUrl = window.location.href;

    const shouldTrack = currentUrl !== previousTrackedUrl;

    if (shouldTrack) {
      track(currentUrl);

      previousTrackedUrl = currentUrl;
    }
  });
}
